import { MetricsBase } from './metrics-base.model';

export class FormInstanceSaveMetrics extends MetricsBase {
    // Static property names.
    private static readonly propertyNames: string[] =
        [
            // Properties from MetricsBase.
            'progressLog',
            'warningLog',
            'errorLog',

            'jobSummaryMessage',

            'exceptionLoggedAndJobTerminated',

            // My properties.
            // Note:  no additional properties at this time.
        ];

    // Properties.
    // Note:  no property at this time.

    // Constructor.
    public constructor(jsonData: Object) {
        super(FormInstanceSaveMetrics.propertyNames, jsonData);
    }

    // Override a method.
    public getJobSummaryText(): string {
        //return this.jobSummaryMessage;
        return this.progressLog;
    }
}
